<template>
  <div class="cell grid-x grid-margin-x">
    <div class="small-12 medium-5 large-3 cell">
      <div class="filterlist_filter">
        <p class="filterlist_filter_headline">Nach Rechtsgebieten filtern</p>
        <div class="spinner" :class="{ spinning: loading }" role="status" aria-label="Gesetze werden geladen"></div>
        <ul>
          <li>
            <input
                type="checkbox"
                id="allegesetze"
                v-model="alleGesetze"
                :value="alleGesetze"
                class="filled-in">
            <label for="allegesetze" class="for-filled-in">Alle Gesetze <span class="lawcount">{{ laws.length }}</span></label>
          </li>

          <li
              v-for="(i, ii) in tags"
              :key="ii"
              @click="toggle(tags[ii])"
              :class="{ toggled: tags[ii].toggled }"
              class="category">
            <input
                type="checkbox"
                :id="tags[ii].name"
                :value="tags[ii].name"
                v-model="tags[ii].selected"
                @change="categoryChange(tags[ii])"
                class="filled-in">
            <label class="for-filled-in" :for="tags[ii].name" :class="{ partlySelected: tags[ii].partlySelected }"></label>
            <span>{{ tags[ii].name }}</span>
            <ul>
              <li v-for="(j, jj) in tags[ii].rechtsgebiets" :key="jj">
                <input
                    type="checkbox"
                    :id="tags[ii].rechtsgebiets[jj].gebiet"
                    :value="tags[ii].rechtsgebiets[jj].gebiet"
                    v-model="tags[ii].rechtsgebiets[jj].selected"
                    @change="rechtsgebietChange(tags[ii])"
                    class="filled-in">
                <label class="for-filled-in" :for="tags[ii].rechtsgebiets[jj].gebiet">
                  {{ tags[ii].rechtsgebiets[jj].gebiet }}
                </label>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="small-12 medium-7 large-9 cell filterlist_items">
      <transition-group name="filterlist">
        <a v-for="law in filteredLaws" :href="law.url_id" v-bind:key="law" class="filterlist_item">
          <span>{{ law.id }}</span>{{ ' ' }}
          <span v-if="law.kurzname.length>0">{{ law.kurzname }}</span>
          <span v-else>{{ law.name }}</span>
        </a>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      loading: false,
      lawsUrl: '/gesetze.json',
      tagsUrl: '/rechtsgebiete.json',
      laws: [],
      tags: [],
      alleGesetze: true,
      bottom: false,
      maxLaws: 100,
      message: 'hallo i bims 1 vue app'
    }
  },
  methods: {
    toggle(x) {
      x.toggled = !x.toggled
    },
    categoryChange(category) {
      if (category.selected === true) {
        category.rechtsgebiets.forEach(function (rechtsgebiet) {
          rechtsgebiet.selected = true
        })
        this.alleGesetze = false
      }
      if (category.selected === false) {
        category.rechtsgebiets.forEach(function (rechtsgebiet) {
          rechtsgebiet.selected = false
        })
      }
      category.partlySelected = false
    },
    rechtsgebietChange(category) {
      let categorySelected = category.rechtsgebiets.filter(function (rechtsgebiet) {
        return rechtsgebiet.selected === true
      })
      if (categorySelected.length === 0) {
        category.selected = false
        category.partlySelected = false
      } else if (categorySelected.length === category.rechtsgebiets.length) {
        category.selected = true
        this.alleGesetze = false
        category.partlySelected = false
      } else {
        console.log("partlySelected")
        category.partlySelected = true
        this.alleGesetze = false
      }
    },
    bottomVisible() {
      const scrollY = window.scrollY + 300
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight
      return bottomOfPage || pageHeight < visible
    }
  },
  watch: {
    alleGesetze: function () {
      if (this.alleGesetze) {
        this.tags.forEach(function (category) {
          category.selected = false
          category.partlySelected = false
          category.toggled = false
          category.rechtsgebiets.forEach(function (rechtsgebiet) {
            rechtsgebiet.selected = false
          })
        })
      }
    },
    bottom: function (bottom) {
      if (bottom) {
        this.maxLaws = this.maxLaws + 100
      }
    }
  },
  computed: {
    filteredLaws: function () {
      var data = this.laws
      var tags = this.tags

      var checkedTags = []
      tags.forEach(function (tag) {
        tag.rechtsgebiets.forEach(function (rechtsgebiet) {
          if (rechtsgebiet.selected == true) {
            checkedTags.push(rechtsgebiet.gebiet)
          }
        })
      })

      if (checkedTags.length > 0) {
        data = data.filter(function (row) {
          if (typeof row.rechtsgebiets[0] !== 'undefined') {
            return Object.keys(row.rechtsgebiets).some(function (i) {
              return Object.keys(checkedTags).some(function (j) {
                return row.rechtsgebiets[i].gebiet.indexOf(checkedTags[j]) > -1
              })
            })
          }
        })
      }
      data.sort(function (a, b) {
        if (a.sort === b.sort) {
          return 0
        } else {
          return (a.sort < b.sort) ? -1 : 1
        }
      })
      data = data.slice(0, this.maxLaws)
      return data
    }
  },
  created() {
    this.loading = true

    var token = $('[name="csrf-token"]').attr('content')
    var fetches = [
      fetch(this.lawsUrl, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
          'Accept': 'application/json'
        },
        credentials: 'same-origin'
      }).then(result => result.json()),
      fetch(this.tagsUrl, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
          'Accept': 'application/json'
        },
        credentials: 'same-origin'
      }).then(result => result.json())
    ]
    Promise.all(fetches).then((results) => {
      if (Object.prototype.toString.call(results[0]) === '[object Array]') {
        //console.log( 'Array!' )
        this.laws = results[0]
        this.tags = results[1]
      } else {
        console.log('Object!')
        this.laws = results[0].gesetzs
        this.tags = results[1].rechtsgebiets
      }
      //console.log("laws: ", this.laws)
      //console.log("tags: ", this.tags)

      var vm = this;
      this.tags.forEach(function (category) {
        vm.$set(category, 'toggled', false)
        vm.$set(category, 'selected', false)
        vm.$set(category, 'partlySelected', false)

        category.rechtsgebiets.forEach(function (rechtsgebiet) {
          vm.$set(rechtsgebiet, 'selected', false)
        })
      })
      this.loading = false
    })
    window.addEventListener('scroll', () => {
      this.bottom = this.bottomVisible()
    })
  }
}
</script>
